import { Dimensions, StyleSheet } from "react-native";

const { width, height } = Dimensions.get("window");

export default StyleSheet.create({
  letterContainer: {
    height: 80,
    width: 80,
    borderWidth: 1,
    borderRadius: 17,
    justifyContent: "center",
    alignItems: "center",
    margin: 6,
    borderBottomWidth: 6,
    shadowColor: "black",
    shadowOffset: {
      width: 0,
      height: 12,
    },
    shadowOpacity: 1,
    shadowRadius: 24,
    elevation: 12,
    borderBottomColor: '#444',
    borderRightColor: '#555',
    borderEndWidth: 6,
    borderRightWidth: 6,
  },
  container: {
    flex: 1,
    backgroundColor: "#18181d",
    alignItems: "center",
    justifyContent: "center",
  },
  header: {
    backgroundColor: "transparent",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    paddingHorizontal: 24,
  },
  pill: {
    backgroundColor: "rgba(0,0,0,0.7)",
    borderRadius: 99,
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  secondsLeft: {
    fontSize: 36,
    fontWeight: "800",
    paddingTop: 2,
    fontFamily: "Baloo",
  },
  introText: {
    textAlign: "center",
    paddingHorizontal: 48,
    fontSize: 16,
    color: "white",
    fontWeight: "800",
    fontFamily: "Baloo",
    lineHeight: 24,
  },
  gameCardText: {
    fontSize: 18,
    color: "white",
    fontWeight: "800",
    fontFamily: "Baloo",
  },
  selectedContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "space-evenly",
    paddingHorizontal: 24,
  },
  letterBox: {
    flexDirection: "row",
    position: "absolute",
    top: "12%",
    backgroundColor: "rgba(0,0,0,0.5)",
    paddingHorizontal: 32,
    paddingTop: 3,
    paddingBottom: 9,
    borderRadius: 32,
    alignItems: "center",
  },
  scoreText: {
    fontWeight: "800",
    color: "white",
    fontSize: 24,
    fontFamily: "Baloo",
  },
  submissionText: {
    color: "plum",
    fontWeight: "800",
    fontSize: 48,
    textAlign: "center",
    alignSelf: "center",
    letterSpacing: 3,
    textDecorationLine: "underline",
    fontFamily: "Baloo",
    textTransform: "uppercase",
  },
  cardContainer: {
    position: "absolute",
    bottom: 48,
  },
  lottie: {
    width: 200,
    height: 200,
    backgroundColor: "transparent",
    alignSelf: "center",
  },
  loadingText: {
    textAlign: "center",
    color: "white",
    fontSize: 24,
    opacity: 0.5,
    fontFamily: "Baloo",
  },
  hint: {
    color: "white",
    opacity: 0.5,
    fontSize: 12,
    fontFamily: "Baloo",
    paddingHorizontal: "12%",
    textAlign: "center",
    paddingTop: 24
  },
  title: {
    color: "#f01d71",
    fontSize: 64,
    fontWeight: "800",
    fontFamily: "Baloo",
    textAlign: "center",
    textShadowColor: "#000",
    textShadowOffset: {
      width: -4,
      height: 4,
    },
    textShadowRadius: 0,
  },
  input: {
    backgroundColor: "white",
    borderRadius: 99,
    paddingHorizontal: 16,
    paddingVertical: 4,
    fontSize: 28,
    fontWeight: "800",
    fontFamily: "Baloo",
    width: "100%",
    textAlign: "center",
    marginBottom: 24,
  },
  dropdown: {
    margin: 23,
    width: width * 0.8,
    padding: 6,
    backgroundColor: "#5D3FD3",
    borderRadius: 99,
    shadowColor: "#959DE7",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.33,
    shadowRadius: 8,
    elevation: 5,
  },
  shadowStyle: {
    shadowColor: 'magenta',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.8,
    shadowRadius: 2,
    elevation: 5, // for Android
  },
  heading: {
    fontSize: 24,
    color: "white",
    fontWeight: "800",
    marginTop: 24,
  },
  paragraph: {
    fontSize: 16,
    color: "white",
    padding: 24,
    opacity: 0.8
  },
  repetitionIndex: {
    position: "absolute",
    top: -8,
    right: -8,
    backgroundColor: '#f01d71',
    width: 24,
    height: 24,
    borderRadius: 99,
    justifyContent: "center",
    alignItems: "center",
  }
});
